const ANY_LABEL = 'any'

export const ANY_REGION_OPTION_LABEL: string = ANY_LABEL

export const ANY_REGION_OPTION = {
    value: -1,
    label: ANY_LABEL
}
